import { NgModule } from '@angular/core';
import { AuthModule } from './auth';

@NgModule({
    imports: [AuthModule],
    providers: [],
    exports: [],
})
export class StingModule {}
